<template>
  <span
    class="font-bold text-primary"
    :style="{
      fontSize: `${height}px`,
      color: colorsComputed.start,
      lineHeight: 1,
    }"
  >
    FBlead
  </span>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useColors } from 'vuestic-ui'

const { getColor } = useColors()

const props = withDefaults(
  defineProps<{
    height?: number
    start?: string
    end?: string
  }>(),
  {
    height: 28,
    start: 'primary',
    end: undefined,
  },
)

const colorsComputed = computed(() => {
  return {
    start: getColor(props.start),
    end: getColor(props.end || props.start),
  }
})
</script>
